// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__26QSs","reject":"style_reject__Q-Jxv","approve":"style_approve__ulBM4"};